/**
 * Resize an image File to fit within maxDim on its longest edge,
 * returning a JPEG Blob. Keeps aspect ratio. Skips resize if already
 * smaller than maxDim. Used to keep design photo storage costs down.
 */
export async function resizeImage(file, maxDim = 1600, quality = 0.85) {
  if (!file.type.startsWith("image/")) return file;

  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const img = await new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = reject;
    i.src = dataUrl;
  });

  const longest = Math.max(img.width, img.height);
  if (longest <= maxDim) {
    return file; // Already small enough
  }

  const scale = maxDim / longest;
  const w = Math.round(img.width * scale);
  const h = Math.round(img.height * scale);

  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", quality)
  );
  // Wrap blob as a File so it has a name + lastModified
  return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", {
    type: "image/jpeg",
    lastModified: Date.now(),
  });
}
